/*
  Prepend a "None" entry to the specified array of options
*/

export default function prependNoneOption(options: Array<object>) {
  return [{ id: null, name: '(none)' }, ...options];
}
